import { useState, useEffect, useMemo } from 'react';
import styles from './homePage.module.css';

import { useAllItemsQuery, useLazyAllItemsQuery } from '../../../store/api/item.api';
import { useAllSubscriptionsQuery } from '../../../store/api/subscription.api';
import { useDebounce } from '../../../hooks/debounce';

import { useInfiniteSwiperSlides } from '../../../hooks/useInfiniteSwiperSlides';
import { useOnScreen } from '../../../hooks/useOnScreen';
import { Header } from '../../../components/Header/Header';
import { Slider } from '../../../components/Slider/Slider';
import { FooterBtn } from '../../../UI/FooterBtn/FooterBtn';
import { MinSliderCard } from '../../../components/Slider/minSliderCard/minSliderCard';
import { MainSliderCard } from '../../../components/Slider/mainSliderCard/mainSliderCard';

import arrowIcon from '../../../assets/arrow_top-icon.svg';
import supportIcon from '../../../assets/support-icon.svg';


export const HomePage = () => {
	useEffect(() => {
		window.sessionStorage.setItem('schema', '');
	}, []);

	const [subParams, setSubParams] = useState({ time: 1, title: "" });
	const [isDropboxShow, setIsDropboxShow] = useState(false);

	
	const [triggerAllItems, { data: allItems = [] }] = useLazyAllItemsQuery();

	const { data: itemsWithDisc = [], isLoading: isSaleLoading } = useAllItemsQuery({
		schema: '',
		params: {price_disc: true, customLimit: 10}
	});

	const { data: inMainSliderItems = []} = useAllItemsQuery({
		schema: '',
		params: { inMainSlider: true}
	})

	const { data: subscriptionsData = [] } = useAllSubscriptionsQuery();

	const sortedLeaders = useMemo(() => {
		return [...allItems].slice(0, 30);
	}, [allItems]);

	const {
		items: leaderItems,
		loadMore: loadMoreLeaders,
	} = useInfiniteSwiperSlides(sortedLeaders, 5);

	const subscriptions = Array.from(
		new Map(subscriptionsData.map(sub => [sub.title, sub])).values()
	);

	const selectedSubTitle = subParams.title || subscriptions[0]?.title;

	const handleDropboxClick = (e, item) => {
		e.preventDefault();
		setSubParams(prev => ({ ...prev, title: item.title }));
		setIsDropboxShow(false);
	};

	const [catalogRef, isCatalogVisible] = useOnScreen({ rootMargin: '0px', threshold: 0.1 });
	const debouncedVisible = useDebounce(isCatalogVisible, 370);

	useEffect(() => {
		if (!allItems.length) {
			triggerAllItems({ schema: '' });
		}
	}, []);

	const renderMinSliderItems = (filterFn) =>
		allItems.filter(filterFn).slice(0, 10).map(item => (
			<MinSliderCard
				key={item.id}
				title={item.title}
				price={item.price}
				price_disc={item.min_price}
				devices={item.devices}
				lang={item.lang}
				img={item.img}
				itemId={item.id}
				buyBtn={true}
			/>
		));

	return (
		<div className={`${styles.homeMain} main`}>
			<Header />

			<div className={styles.slider_block}>
				<Slider sliderType="main">
					{inMainSliderItems?.map(item => (
						<MainSliderCard key={item.id} {...item} itemId={item.id} />
					))}
				</Slider>
			</div>

			<div className={styles.salesLead_block}>
				<h2>Распродажа</h2>
				<Slider sliderType="min" sliderId={'sale'}>
					{itemsWithDisc.length > 0
						? itemsWithDisc.map(item => (
							<MinSliderCard
								key={item.id}
								title={item.title}
								price={item.price}
								price_disc={item.min_price}
								devices={item.devices}
								lang={item.lang}
								img={item.img}
								itemId={item.id}
								buyBtn
							/>
						))
						: 'Загрузка...'}
				</Slider>
			</div>

			<div className={styles.subs_block}>
				<div className={styles.dropbox_block}>
					<div className={styles.dropbox} onClick={() => setIsDropboxShow(!isDropboxShow)}>
						<div className={styles.dropbox_text}>
							<p>Подписки</p>
							<span>{selectedSubTitle}</span>
						</div>
						<img
							src={arrowIcon}
							alt="arrowIcon"
							className={`${styles.arrow} ${isDropboxShow ? styles.arrowOpen : ''}`}
						/>
					</div>
					{isDropboxShow && (
						<ul className={styles.dropbox_content}>
							{subscriptions.map(item => (
								<li
									key={item.id}
									className={styles.dropbox_item}
									onClick={(e) => handleDropboxClick(e, item)}
								>
									{item.title}
								</li>
							))}
						</ul>
					)}
				</div>

				<div className={styles.timeSubs}>
					{[1, 3, 12].map(month => (
						<div
							key={month}
							className={`${styles.timeSubs_item} ${subParams.time === month ? styles.timeActive : ''}`}
							onClick={() => setSubParams(prev => ({ ...prev, time: month }))}
						>
							{month} месяц{month === 3 ? 'a' : month === 12 && 'ев'}
						</div>
					))}
				</div>
			</div>

			<div className={styles.subs_slider}>
				<Slider sliderType="min" sliderId={'subs'}>
					{subscriptionsData
						.filter(sub => sub.title === selectedSubTitle && sub.time === subParams.time)
						.map(item => (
							<MinSliderCard
								key={item.id}
								{...item}
								style={{height: 300}}
								buyBtn
								subscriptionId={item.id}
								subCategory={item.category}
							/>
						))}
				</Slider>
			</div>

			<div ref={catalogRef} className={styles.catalog_sliders}>
				{
					debouncedVisible && (
						<>
							<div className={styles.catalog_slider}>
								<h2>Лидеры продаж</h2>
								<Slider sliderType="min" sliderId={'leaders'} onReachEnd=				{loadMoreLeaders}>
									{leaderItems.map(item => (
										<MinSliderCard key={item.id} {...item} price_disc={item.min_price} itemId={item.id} buyBtn />
									))}
								</Slider>
							</div>

							<div className={styles.catalog_slider}>
								<h2>Предзаказ</h2>
								<Slider sliderType="min" sliderId={'preOrder'}>
									{renderMinSliderItems(item => {
										const now = new Date();
										return new Date(item.releaseDate) > now
									})}
								</Slider>
							</div>

							<div className={styles.catalog_slider}>
								<h2>До 500</h2>
								<Slider sliderType="min" sliderId={'500'}>
									{renderMinSliderItems(item => {
										const price = item.price_disc_sub || item.price_disc || item.price;
										return price <= 500;
									})}
								</Slider>
							</div>

							<div className={styles.catalog_slider}>
								<h2>До 1000</h2>
								<Slider sliderType="min" sliderId={'1000'}>
									{renderMinSliderItems(item => {
										const price = item.price_disc_sub || item.price_disc || item.price;
										return price > 500 && price <= 1000;
									})}
								</Slider>
							</div>

							<div className={styles.catalog_slider}>
								<h2>Полностью на русском</h2>
								<Slider sliderType="min" sliderId={'fullRu'}>
									{renderMinSliderItems(item => item.lang === 'Полностью на русском')}
								</Slider>
							</div>
						</>
					)
				}
			</div>

			<footer className={styles.footer}>
				<FooterBtn
					title="Support"
					url="https://t.me/eazysupp"
					description="На всякий случай, если у вас будут вопросы"
					img={supportIcon}
				/>
			</footer>
		</div>
	);
};
